import * as React from 'react';
import * as ReactDOM from 'react-dom';

var Portal = function Portal(_ref) {
  var children = _ref.children,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? document.body : _ref$container;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    "data-testid": "portal"
  }, children), container);
};
Portal.displayName = 'Portal';

export { Portal };
//# sourceMappingURL=Portal.js.map
